<template>
  <div class="justify-space-between py-8">
    <div :class="boxClasses" class="ma-0 d-flex justify-start align-start flex-wrap module-box" style="justify-content: center">
      <div
        v-for="(module, ind) in modules"
        @click="navigateToModule(module)"
        :key="ind"
        class="box d-flex align-center flex-column"
        :style="boxStyle"
        :class="config.background ? config.background[themeName] : ''"
      >
        <div class="icon-title-wrapper d-flex flex-column mx-auto align-center">
          <module-icon-with-badge
            v-if="config.badgeOutsideOfBox"
            :isUnreadCountFeatureEnabled="false"
            :iconColor="iconColor"
            :module="module"
            :iconHeight="iconHeight"
            :iconWidth="iconWidth"
            :size="iconSize"
          ></module-icon-with-badge>

          <module-icon-with-badge
            v-else
            :unreadCountBadgeColor="badgeColor"
            :isUnreadCountFeatureEnabled="mx_isUnreadCountFeatureEnabled(module.type, module.instance)"
            :iconColor="iconColor"
            :module="module"
            :unreadCount="mx_unreadCount(module)"
            :iconHeight="iconHeight"
            :iconWidth="iconWidth"
            :size="iconSize"
          ></module-icon-with-badge>

          <div
            class="text-subtitle-2 mb-2 align-center justify-center text-center module-title"
            :class="textClasses"
            style="white-space: pre-line; width: 100%"
          >
            {{ $te(module.title) ? $t(module.title) : module.title }}
          </div>
          <module-box-badge
            v-if="mx_isUnreadCountFeatureEnabled(module.type, module.instance) && config.badgeOutsideOfBox"
            :count="mx_unreadCount(module)"
            :badgeColor="badgeColor"
          ></module-box-badge>
          <!-- <div v-if="config.badgeOutsideOfBox && mx_unreadCount(module) > 0" class="op-badge" :class="badgeColor" :style="badgeStyle">
                                {{ mx_unreadCount(module) }}
                              </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import ModuleIconWithBadge from '@/components/icons/ModuleIconWithBadge.vue';
import ModuleBoxBadge from './ModuleBoxBadge.vue';

export default {
  name: 'ModuleBox',
  mixins: [common, configMixin, navigationMixin],
  components: {
    ModuleIconWithBadge,
    ModuleBoxBadge,
  },

  props: {
    config: Object,
  },
  methods: {
    navigateToModule(module) {
      let path = this.buildRoute(module);
      console.debug('ModuleBox navigateToModule', path);
      this.$router.push(path);
    },
  },
  computed: {
    boxStyle() {
      //let style = {width: (this.config.boxWidth ? this.config.boxWidth : 150) + 'px'};
      let style = { position: 'relative' };
      if (this.config.style) style = { ...style, ...this.config.style };

      if (this.config.boxWidth) {
        if (isNaN(Number(this.config.boxWidth))) {
          style.width = this.config.boxWidth;
        } else {
          style.width = `${this.config.boxWidth}px`;
        }
      }

      if (!style.minWidth) style.minWidth = '100px';
      if (!style.width) style.width = '50%';
      return style;
    },
    badgeStyle() {
      return {
        position: 'absolute',
        top: '-10px',
        right: '-10px',
      };
    },
    iconWidth() {
      return this.config.iconWidth;
    },
    iconHeight() {
      return this.config.iconHeight;
    },
    iconSize() {
      return this.config.iconSize;
    },
    iconColor() {
      return this.config.iconColor[this.themeName];
    },
    badgeColor() {
      return this.config.badgeColor && this.config.badgeColor[this.themeName] ? this.config.badgeColor[this.themeName] : this.theme.unreadBadgeColor;
    },
    boxClasses() {
      let boxClasses = '';

      if (this.config.hasBorder) {
        boxClasses = `module-box-border-${this.darkMode ? 'dark' : 'light'}`;
      }
      console.debug('hasBorder:', this.config.hasBorder, boxClasses);
      return boxClasses;
    },
    textClasses() {
      return this.config.fontColor ? `${this.config.fontColor[this.themeName]}--text` : '';
    },
  },
};
</script>

<style scoped>
.module-title {
  font-size: 0.9em !important;
}

.icon-title-wrapper {
  border-radius: 5px;
}

.box {
  cursor: pointer;
  box-sizing: border-box;
  margin: 5px;
}

/* xs -x-small */
@media (max-width: 599px) {
  .box {
    /*width: calc(50% - 32px);*/
  }
}

/* sm - small */
@media (min-width: 600px) and (max-width: 959px) {
  .box {
    /*width: calc(25% - 32px);*/
  }
}

/* md - medium */
@media (min-width: 960px) and (max-width: 1263px) {
  .box {
    /*width: calc(20% - 32px);*/
  }
}

/* lg - large */
@media (min-width: 1264px) and (max-width: 1904px) {
  .box {
    /*width: calc(16.6% - 32px);*/
  }
}

/* xl - extra large */
@media (min-width: 1905px) {
  .box {
    /*width: calc(10% - 32px);*/
  }
}

.module-box-border-dark {
  box-shadow: 0 0 17px 1px #010101;
  border: 1px solid black !important;
  border-radius: 4px;
}

.module-box-border-light {
  box-shadow: 0 0 17px 1px #cbc6c6;
  border: 1px solid #d5d3d3 !important;
  border-radius: 4px;
}
</style>
